import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import i18n from '@/plugins/i18n';
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCarousel from 'vue-carousel'
import FlagIcon from 'vue-flag-icon';
import vuetify from './plugins/vuetify';


import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

 
Vue.use(FlagIcon)
Vue.use(VueAxios, axios)
Vue.use(VueCarousel);

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
